import type { AgentDeploymentResource as AgentDeploymentResourceModel } from '@/adapters/catalogv1.g';

export function extractAgentDeploymentResource(
  model: AgentDeploymentResourceModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deploymentRef: model.deployment_ref ?? '',
    resourceRef: model.resource_ref ?? '',
    relationship: model.relationship ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentDeploymentResource = ReturnType<
  typeof extractAgentDeploymentResource
>;
